/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetPlayerDetails200ResponseCardLevelMatrixInner
 */
export interface GetPlayerDetails200ResponseCardLevelMatrixInner {
    /**
     * 
     * @type {number}
     * @memberof GetPlayerDetails200ResponseCardLevelMatrixInner
     */
    level?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200ResponseCardLevelMatrixInner
     */
    name?: string;
}


/**
 * Check if a given object implements the GetPlayerDetails200ResponseCardLevelMatrixInner interface.
 */
export function instanceOfGetPlayerDetails200ResponseCardLevelMatrixInner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetPlayerDetails200ResponseCardLevelMatrixInnerFromJSON(json: any): GetPlayerDetails200ResponseCardLevelMatrixInner {
    return GetPlayerDetails200ResponseCardLevelMatrixInnerFromJSONTyped(json, false);
}

export function GetPlayerDetails200ResponseCardLevelMatrixInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayerDetails200ResponseCardLevelMatrixInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'level': !exists(json, 'level') ? undefined : json['level'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function GetPlayerDetails200ResponseCardLevelMatrixInnerToJSON(value?: GetPlayerDetails200ResponseCardLevelMatrixInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'level': value.level,
        'name': value.name,
    };
}

